import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'reactstrap';
import './styles.scss';
import { Translate } from "react-localize-redux";

class CollapseContainer extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: !props.startCollapsed };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    const { children, title } = this.props;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-10">
            <h4 className="collapse-title">{title}</h4>
          </div>
          <div className="col-2">
            {this.state.collapse ?
              <h4 className="collapse-toggle" onClick={this.toggle}>
                <i className="fa fa-caret-up"></i> <Translate id="Close" />
              </h4>
              : <h4 className="collapse-toggle" onClick={this.toggle}>
                <i className="fa fa-caret-down"></i> <Translate id="Open" />
              </h4>
            }
          </div>
        </div>
        <Collapse isOpen={this.state.collapse}>
          <br />
          {children}
        </Collapse>
      </React.Fragment>
    );
  }
}

CollapseContainer.PropTypes = {
  startCollapsed: PropTypes.bool,
  title: PropTypes.string,
};

CollapseContainer.defaultProps = {
  startCollapsed: true,
};

export default CollapseContainer;


// WEBPACK FOOTER //
// ./src/components/CollapseContainer/CollapseContainer.jsx